

























































































































import { Component, Prop, Model, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { MessageType } from "@/store/modules/enums";
import { randomId, formatPhone } from "@/utils";
import { BPopover } from "bootstrap-vue";

@Component({
  components: {
    BPopover,
  },
  filters: {
    phone: formatPhone,
  },
  computed: mapState("patients", ["phoneStatus"]),
})
export default class SMSPopover extends Vue {
  @Model("change") readonly gap!: any;
  id = "sms-popover";
  loading = false;
  templates = Array<any>();
  templateId = "";
  phoneStatus!: Array<any>;
  invalidPhoneStatus = ["NP", "NM", "WN", "IN", "ST", "ER"];
  preview = {
    show: false,
    text: "",
  };
  saved = false;
  error = null;
  get target() {
    return this.id + "-target-" + this.gap.id;
  }
  async getTemplates() {
    try {
      const data = await this.$store.dispatch(
        "gaps/getMeasureTypeTemplates",
        this.gap.measureTypeId
      );
      this.templates = data.filter((t) => t.hasSMSConfig);
      if (this.templates.length === 1) {
        this.templateId = this.templates[0].id;
        this.getPreviewText();
      }
    } catch (error) {
      console.log(error);
    }
  }
  async getPreviewText() {
    this.loading = true;
    try {
      const gapId = this.gap.id;
      const { templateId } = this;
      this.preview.text = await this.$store.dispatch(
        "notifs/getGapSMSPreview",
        {
          gapId,
          templateId,
        }
      );
    } catch (err) {
      console.log(err);
    } finally {
      this.loading = false;
    }
  }
  async setPhones() {
    const { gap, invalidPhoneStatus } = this;
    gap.notifPhones = [];
    gap.notifPhone = null;
    // CHECK MOBILE PHONE
    if (gap.mobilePhone) {
      gap.notifPhones.push({
        key: randomId(6),
        type: "M ",
        number: gap.mobilePhone,
        status: this.phoneStatus.find((s) => s.id === gap.mobilePhoneStatusId)
          .name,
        valid: !invalidPhoneStatus.includes(gap.mobilePhoneStatusId),
      });
    }
    // CHECK HOME PHONE
    if (gap.homePhone) {
      gap.notifPhones.push({
        key: randomId(6),
        type: "H ",
        number: gap.homePhone,
        status: this.phoneStatus.find((s) => s.id === gap.homePhoneStatusId)
          .name,
        valid: !invalidPhoneStatus.includes(gap.homePhoneStatusId),
      });
    }
    // CHECK OTHER PHONE
    if (gap.otherPhone) {
      gap.notifPhones.push({
        key: randomId(6),
        type: "O",
        number: gap.otherPhone,
        status: this.phoneStatus.find((s) => s.id === gap.otherPhoneStatusId)
          .name,
        valid: !invalidPhoneStatus.includes(gap.otherPhoneStatusId),
      });
    }
    // CHECK OTHER PHONE 2
    if (gap.otherPhone2) {
      gap.notifPhones.push({
        key: randomId(6),
        type: "O",
        number: gap.otherPhone2,
        status: this.phoneStatus.find((s) => s.id === gap.otherPhone2StatusId)
          .name,
        valid: !invalidPhoneStatus.includes(gap.otherPhone2StatusId),
      });
    }
    // CHECK VALID PHONES
    const validPhones = gap.notifPhones.filter((p) => p.valid);
    //
    if (validPhones.length) {
      gap.notifPhone = validPhones[0];
    } else {
      gap.notifPhone = gap.notifPhones[0];
    }
    //
  }
  async save() {
    this.loading = true;
    this.error = null;
    try {
      const { gap } = this;
      const gapId = gap.id;
      const toPhone = gap.notifPhone.number;
      const { templateId } = this;
      const { campaignId, patientName } = gap;
      // SAVE NOTIF BATCH
      const { batchId } = await this.$store.dispatch("notifs/saveBatch", {
        campaignId,
        templateId,
        providerTemplateId: null,
        messageType: MessageType.SMS,
        description: patientName,
      });
      // SAVE NOTIF GAP
      await this.$store.dispatch("notifs/saveGap", {
        batchId,
        gapId,
        toPhone,
      });
      gap.smsNotifCount++;
      gap.lastSMSNotif = this.$moment().toString();
      //
      this.saved = true;
    } catch (error) {
      this.error = error;
    } finally {
      this.loading = false;
    }
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    this.getTemplates();
    this.setPhones();
  }
}
